const n=()=>{if("undefined"==typeof window)return!1;try{return window.self!==window.top}catch(n){return!0}};export{n as detectInIframe};
//# sourceMappingURL=detectInIframe.js.map
